<template>
    <DButton
        id="change-language"
        v-c-tooltip="__('messages.header.language_button.title')"
        icon="web"
        @click="changeLanguage"
    />
</template>

<script>
import DButton from '~@/Components/Common/DButton'

export default {
    name: 'DChangeLanguage',
    components: {
        DButton
    },
    created () {
        window.addEventListener('keydown', this.handleKeys)
    },
    methods: {
        changeLanguage () {
            this.$inertia.post(this.$route('users.change_language'))
        },
        handleKeys (event) {
            // CTRL + ALT + L on Windows
            // Control + Option + L on Mac OS
            if (event.ctrlKey && event.altKey && event.key === 'l') {
                event.preventDefault()

                this.changeLanguage()
            }
        }
    }
}
</script>
